<div class="content notification-campaign-detail">
  <!-- Breadcrumb -->
  <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
    <div class="my-auto mb-2">
      <h2 class="mb-1">{{ campaign?.title || 'Campaign' }}</h2>
      <nav>
        <ol class="breadcrumb mb-0">
          <li class="breadcrumb-item">
            <a href="#"><i class="ti ti-smart-home"></i></a>
          </li>
          <li class="breadcrumb-item">Super Admin</li>
          <li class="breadcrumb-item">
            <a href="javascript:void(0)" (click)="goBack()">Notification Campaigns</a>
          </li>
          <li class="breadcrumb-item active" aria-current="page">History</li>
        </ol>
      </nav>
    </div>
    <div class="ms-2 d-flex gap-2">
      <button *ngIf="canStop()" class="btn btn-danger" (click)="stop()">Stop</button>
      <button *ngIf="canRetry()" class="btn btn-secondary" (click)="retry()">Retry Failed</button>
      <!-- <button class="btn btn-light" (click)="goBack()">
        <i class="ti ti-arrow-left me-1"></i>Back
      </button> -->
    </div>
  </div>

  <!-- Summary card -->
  <div class="row" *ngIf="campaign">
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-md-3">
            <p class="mb-1 text-muted">Status</p>
            <span [ngClass]="statusClass(campaign.status)">{{ campaign.status | capitalize }}</span>
          </div>
          <div class="col-md-3">
            <p class="mb-1 text-muted">Channel</p>
            <p>{{ channelLabel(campaign.channel) }}</p>
          </div>
          <div class="col-md-3">
            <p class="mb-1 text-muted">Total Recipients</p>
            <p>{{ campaign.totalRecipients }}</p>
          </div>
          <div class="col-md-3">
            <p class="mb-1 text-muted">Progress</p>
            <div class="progress-cell">
              <div class="progress-bar-bg">
                <div class="progress-bar-fill" [style.width.%]="progressPercent()"></div>
              </div>
              <span class="progress-text">{{ progressPercent() }}%</span>
            </div>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-md-3" *ngIf="campaign.channel !== 'email'">
            <p class="mb-1 text-muted">Push</p>
            <p>{{ campaign.pushSentCount }} sent, {{ campaign.pushFailedCount }} failed</p>
          </div>
          <div class="col-md-3" *ngIf="campaign.channel !== 'push'">
            <p class="mb-1 text-muted">Email</p>
            <p>{{ campaign.emailSentCount }} sent, {{ campaign.emailFailedCount }} failed</p>
          </div>
          <div class="col-md-3">
            <p class="mb-1 text-muted">Scheduled/Sent At</p>
            <p>
              {{
                campaign.scheduledAt || campaign.startedAt
                  ? (campaign.scheduledAt || campaign.startedAt | date: 'dd MMM yyyy, hh:mm a')
                  : '-'
              }}
            </p>
          </div>
          <div class="col-md-3" *ngIf="campaign.completedAt">
            <p class="mb-1 text-muted">Completed At</p>
            <p>{{ campaign.completedAt | date: 'dd MMM yyyy, hh:mm a' }}</p>
          </div>
        </div>

        <p class="text-danger mt-2 mb-0" *ngIf="campaign.errorMessage">
          <strong>Error:</strong> {{ campaign.errorMessage }}
        </p>
        <!--  <div class="mt-2 mb-0" [innerHTML]="campaign.message"></div> -->
      </div>
    </div>
  </div>

  <!-- Recipient list -->
  <div class="row">
    <div class="card">
      <div
        class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3"
      >
        <h5>Recipients ({{ recipientsTotal }})</h5>
        <div class="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
          <div class="me-3">
            <select
              class="form-select form-select-sm"
              [(ngModel)]="pageLimit"
              (change)="onPageLimitChange()"
            >
              <option *ngFor="let limit of [20, 50, 100]" [value]="limit">{{ limit }}</option>
            </select>
          </div>
          <div class="me-3" style="min-width: 200px">
            <select class="form-select" [(ngModel)]="filterBusinessId" (change)="onFilterChange()">
              <option value="">All Businesses</option>
              <option *ngFor="let b of businesses$ | async" [value]="b.id">
                {{ b.businessName }}
              </option>
            </select>
          </div>
          <div class="me-3" *ngIf="campaign?.channel !== 'email'">
            <select class="form-select" [(ngModel)]="filterPushStatus" (change)="onFilterChange()">
              <option value="">All Push Status</option>
              <option *ngFor="let s of deliveryStatusOptions" [value]="s">
                {{ s | capitalize }}
              </option>
            </select>
          </div>
          <div class="me-3" *ngIf="campaign?.channel !== 'push'">
            <select class="form-select" [(ngModel)]="filterEmailStatus" (change)="onFilterChange()">
              <option value="">All Email Status</option>
              <option *ngFor="let s of deliveryStatusOptions" [value]="s">
                {{ s | capitalize }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <div class="card-body p-0">
        <div class="custom-datatable-filter table-responsive">
          <table class="table datatable">
            <thead class="thead-light">
              <tr>
                <th>User</th>
                <th>Email</th>
                <th>Business</th>
                <th *ngIf="campaign?.channel !== 'email'">Push Status</th>
                <th *ngIf="campaign?.channel !== 'push'">Email Status</th>
                <th>Failure Reason</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let r of recipients">
                <td>{{ r.user?.firstName }} {{ r.user?.lastName }}</td>
                <td>{{ r.user?.email || '-' }}</td>
                <td>{{ r.businessName || '-' }}</td>
                <td *ngIf="campaign?.channel !== 'email'">
                  <span [ngClass]="statusClass(r.pushStatus)">{{ r.pushStatus | capitalize }}</span>
                </td>
                <td *ngIf="campaign?.channel !== 'push'">
                  <span [ngClass]="statusClass(r.emailStatus)">{{
                    r.emailStatus | capitalize
                  }}</span>
                </td>
                <td class="text-danger">{{ failureReason(r) }}</td>
              </tr>
              <tr *ngIf="!recipientsLoading && recipients.length === 0">
                <td colspan="6" class="empty-row text-center">No recipients found</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div
        class="d-flex align-items-center justify-content-between ms-2"
        *ngIf="!recipientsLoading && recipients.length !== 0"
      >
        <div>
          Showing {{ (currentPage - 1) * pageLimit + 1 }} to {{ pageLastRecord }} of
          {{ recipientsTotal }} entries
        </div>
        <div class="has-text-centered mt-3">
          <app-pagination
            [currentPage]="currentPage"
            [pageSize]="pageLimit"
            [totalRows]="recipientsTotal"
            (pageChange)="onPageChange($event)"
          ></app-pagination>
        </div>
      </div>
    </div>
  </div>
</div>
